import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';

dayjs.extend(relativeTime);
dayjs.extend(duration);

const timersModule = {

    pluralize(n, forms) {
        const mod10 = n % 10;
        const mod100 = n % 100;

        if (mod10 === 1 && mod100 !== 11) {
            return `${n} ${forms[0]}`;      // форма для 1
        } else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
            return `${n} ${forms[1]}`;      // форма для 2-4
        } else {
            return `${n} ${forms[2]}`;      // форма для остальных
        }
    },

    updateCountdown(timer) {
        const targetDate = dayjs(timer.dataset.timer)
        const now = dayjs();
        const diff = targetDate.diff(now);

        if (diff <= 0) {
            clearInterval(timer);
            return;
        }

        const timeLeft = dayjs.duration(diff);
        const years = timeLeft.years();
        const months = timeLeft.months();
        const days = timeLeft.days();
        const hours = timeLeft.hours();
        const minutes = timeLeft.minutes();

        let output = [];

        if(years) {
            output.push(this.pluralize(years,timer.dataset.years.split('|'))) ;
        }
        if(months) {
            output.push(this.pluralize(months,timer.dataset.months.split('|'))) ;
        }
        if(days) {
            output.push(this.pluralize(days,timer.dataset.days.split('|'))) ;
        }
        if(hours) {
            output.push(this.pluralize(hours,timer.dataset.hours.split('|'))) ;
        }
        if(minutes) {
            output.push(this.pluralize(minutes,timer.dataset.minutes.split('|'))) ;
        }

        $(timer).text(output.join(' '));
    },


    init() {
        const timers = document.querySelectorAll('[data-timer]');

        timers.forEach(timer => {
            setInterval(() => this.updateCountdown(timer), 1000);
        });
    }
}

export default timersModule;
